import {BaseMatchedTransaction} from "../model/MatchedDocument";
import {jsonMapper} from "../utils/DataParser";
import {Nil} from "../utils/Types";
import {BankAccountCode} from "../model/BankAccountCode";

const PREFIX_KEY = "TransactionsExchange"
const EXPIRE_AFTER_MINUTES = 30;

interface StoreObj {
    bank: BankAccountCode,
    txs: BaseMatchedTransaction[]
}

class TransactionsExchange {

    public getTransactions(id: string): StoreObj | Nil {
        this.clearOldItems();
        const item = localStorage.getItem(this.formatKey(id));
        if (item) {
            return jsonMapper.parse(item).data
        }
        return undefined;
    }

    private formatKey(id: string) {
        return PREFIX_KEY + "_" + id;
    }

    private async clearOldItems() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)!!;
            if (key.includes(PREFIX_KEY)) {
                const item = jsonMapper.parse(localStorage.getItem(key)!!)
                if (item.expireAfter < new Date()) {
                    localStorage.removeItem(key)
                }
            }
        }
    }

    public setTransactions(bank: BankAccountCode, txs: BaseMatchedTransaction[]): string {
        const id = Math.floor(Math.random() * 100000).toString()
        const expireAfter = new Date(new Date().getTime() + EXPIRE_AFTER_MINUTES * 60000)

        let obj: { data: StoreObj, expireAfter: Date } = {
            data: {
                bank: bank,
                txs: txs
            },
            expireAfter: expireAfter
        }

        localStorage.setItem(this.formatKey(id), jsonMapper.stringify(obj))
        return id;
    }
}

export const transactionsExchangeStore = new TransactionsExchange();
